import React, { useEffect, useState } from "react";
import { useDrag } from "react-dnd";
import { ItemSubtypes, ItemTypes } from "../../../DnDTypes";
import * as classnames from "classnames";
import styles from "./index.module.css";
import s from "./index.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// dragaMode = either 'clone' or 'move'

const useStyles = makeStyles((theme) => ({
  fontSize: {
    "& .MuiAlert-icon": {
      fontSize: theme.typography.body1.iconSize,
    },
    fontSize: theme.typography.body1.fontSize,
  },
  fontSizeHintText: {
    "& .MuiAlert-icon": {
      fontSize: theme.typography.body1.iconSize,
    },
    fontSize: theme.typography.body2.hintText,
  },
}));

const BoolControl = ({
  name,
  id,
  disabled,
  isSelected = false,
  dragMode = "move",
  configuration = {},
  markSelected,
  onChange,
  showSelfDescription,
  sidebarMode,
  formCreatorMode,
  onRemove,
  rowIndex,
  index,
  setIsDragging,
  filledValue,
  blankedRequiredFields,
  checkBlankedFields,
  displayMode,
}) => {
  const [, drag] = useDrag({
    item: {
      type: ItemTypes.COMPONENT,
      subtype: ItemSubtypes.BOOL,
      dragMode,
      defaultLabel: "Tak/Nie",
      id,
      rowIndex,
      index,
    },
    collect: (monitor, props) => {
      setIsDragging && setIsDragging(!!monitor.isDragging());

      return {
        isDragging: !!monitor.isDragging(),
      };
    },
    canDrag: () => {
      return dragMode === "move" || dragMode === "clone";
    },
  });

  const classes = useStyles();
  const globalTheme = useSelector((s) => s.globalTheme);
  const isJustUser = useSelector((s) => s.my.user.authorities === "ROLE_PATIENT");

  const [value, setValue] = useState(filledValue === true || filledValue === "true");

  useEffect(() => {
    setValue(filledValue === true || filledValue === "true");
  }, [filledValue]);

  const clicked = () =>
    markSelected &&
    markSelected({
      id,
      dataType: ItemSubtypes.BOOL,
      configuration,
    });

  const updateValue = (checked) => {
    setValue(checked);

    if (onChange) {
      onChange({
        id,
        value: checked,
      });
    }
  };

  if (sidebarMode) {
    return (
      <div ref={drag}>
        <input
          readOnly={true}
          type="checkbox"
          className="checkbox"
        />
        <label style={{ marginLeft: "8px" }}>Tak/Nie</label>
      </div>
    );
  }

  const placeholder = showSelfDescription ? "Tak/Nie" : configuration.text || "";
  const label = (configuration && configuration.label) || "";

  if (formCreatorMode) {
    return (
      <div ref={drag}>
        {label && <label className={classnames("label")}>{label}</label>}
        {!label && (
          <label
            dangerouslySetInnerHTML={{ __html: "&nbsp;" }}
            className={classnames("label")}
          ></label>
        )}
        <div ref={drag} className={s.relative}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <input
              type="checkbox"
              className={classnames("checkbox", {
                [s.hasActiveConfiguration]: isSelected,
              })}
              name={name}
              id={id}
              onClick={clicked}
              readOnly
            />
            <label style={{ marginLeft: "8px" }}>{placeholder}</label>
          </div>
          {!displayMode && (
            <FontAwesomeIcon
              className={classnames(s.trashIcon, "has-text-grey")}
              onClick={onRemove}
              icon="trash"
              title="Usuń"
            />
          )}
        </div>
      </div>
    );
  }

  return (
    <div ref={drag}>
      {label && (
        <label
          className={`label ${classes.fontSize}`}
          style={{ color: globalTheme === "high-contrast" && "yellow" }}
        >
          {label}
          {configuration.required && " *"}
        </label>
      )}
      {!label && (
        <label
          dangerouslySetInnerHTML={{ __html: "&nbsp;" }}
          className={classnames("label")}
        ></label>
      )}
      {disabled && !isJustUser && !value ? (
        <div
          className={`${s.hintText} ${classes.fontSize}`}
          style={{ color: globalTheme === "high-contrast" && "yellow" }}
        >
          Pole niewypełnione przez{" "}
          {process.env.REACT_APP_USE_PATIENT === "true"
            ? "pacjenta"
            : "użytkownika"}
        </div>
      ) : (
        <>
          <FormControlLabel
            control={
              <Checkbox
                checked={value}
                onChange={(e) => updateValue(e.target.checked)}
                onClick={clicked}
                disabled={disabled}
                name={name}
                id={id}
                style={{
                  color: globalTheme === "high-contrast" ? "yellow" : undefined,
                }}
              />
            }
            label={placeholder}
            style={{
              color: globalTheme === "high-contrast" ? "yellow" : undefined,
            }}
          />
          {checkBlankedFields &&
            blankedRequiredFields.find((fieldId) => fieldId === id) && (
              <p
                className={`${classes.fontSize} ${
                  globalTheme !== "high-contrast" && "help is-danger"
                }`}
                style={{
                  color: globalTheme === "high-contrast" && "#df9700",
                }}
              >
                To pole musi zostać wypełnione
              </p>
            )}
        </>
      )}
    </div>
  );
};

export default BoolControl;
